import './image-content-switcher.scss';

class ImageContentSwitcher {
    constructor (element, options) {
        const settings = {
        };

        this.settings = Object.assign({}, settings, options);

        this.$imageContentSwitcher = element;
        this.$$tabs = Array.from(this.$imageContentSwitcher.querySelectorAll('[role="tab"]'));
        this.$$tabPanels = this.$$tabs.map($tab => {
            const id = $tab.getAttribute('aria-controls');
            return document.getElementById(id);
        }).filter(el => el !== null);

        this.$firstTab = this.$$tabs[0];
        this.$lastTab = this.$$tabs[this.$$tabs.length - 1];

        this.$$tabs.forEach(($tab, index) => {
            $tab.addEventListener('keydown', this.onKeydown.bind(this));
            $tab.addEventListener('click', this.onClick.bind(this));
        });

        this.initSlider();
        this.initResizeObserver();
    }

    initResizeObserver () {
        if (typeof ResizeObserver !== 'undefined') {
            this.resizeObserver = new ResizeObserver(() => {
                this.updateAllSliders();
            });
            this.resizeObserver.observe(this.$imageContentSwitcher);
        }
    }

    initSlider () {
        this.$$tabPanels.forEach(($panel, index) => {
            const $tab = this.$$tabs[index];
            const isSelected = $tab.getAttribute('aria-selected') === 'true';

            if (isSelected) {
                // Nur initialisieren, wenn das Element auch wirklich sichtbar ist
                if (this.$imageContentSwitcher.offsetParent !== null) {
                    this.initPanelSlider($panel);
                }
            }
        });
    }

    initPanelSlider ($panel) {
        if ($panel.sliderInstance || $panel.sliderInitializationStarted) {
            return;
        }

        // Sicherheitscheck: Wenn der Container versteckt ist (offsetParent === null),
        // wird die Initialisierung abgebrochen, um 0px-Höhen zu vermeiden.
        if (this.$imageContentSwitcher.offsetParent === null) {
            return;
        }

        const $slider = $panel.querySelector('[data-imagecontentswitcher="slider"]');
        const $slides = $panel.querySelector('[data-imagecontentswitcher="slides"]');

        if ($slider && $slides) {
            const $$slidesItems = $slides.querySelectorAll('[data-imagecontentswitcher="slide"]');
            if ($$slidesItems.length > 1) {
                $panel.sliderInitializationStarted = true;
                $panel.sliderInstance = import('../../components/slider/slider').then(({ Slider }) => {
                    const instance = new Slider($slider, {
                        speed: 500,
                        slidesPerView: 'auto',
                        initAttr: 'data-imagecontentswitcher',
                        indicators: true,
                        prevnext: true,
                        breakpoints: null
                    });
                    $panel.sliderInstance = instance; // Replace promise with instance
                    return instance;
                });
            } else {
                $slider.classList.add('no-slider');
            }
        }
    }

    setSelectedTab ($currentTab, setFocus) {
        if (typeof setFocus === 'undefined') {
            setFocus = true;
        }

        const $infoBar = document.querySelector('.product-info-bar');
        let infoBarRectBefore = null;
        if ($infoBar) {
            infoBarRectBefore = $infoBar.getBoundingClientRect();
        }

        this.$$tabs.forEach(($tab, index) => {
            const $panel = this.$$tabPanels[index];
            const isSelected = $tab === $currentTab;

            $tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
            $tab.tabIndex = isSelected ? 0 : -1;

            if (isSelected) {
                $tab.classList.add('image-content-switcher__tab-button--active');
                if ($panel) {
                    $panel.classList.add('image-content-switcher__contents--active');
                    $panel.removeAttribute('hidden');

                    if (!$panel.sliderInstance && !$panel.sliderInitializationStarted) {
                        this.initPanelSlider($panel);
                    } else if ($panel.sliderInstance) {
                        if ($panel.sliderInstance.slider) {
                            window.requestAnimationFrame(() => {
                                $panel.sliderInstance.slider.update();
                            });
                        } else if (typeof $panel.sliderInstance.then === 'function') {
                            // Instance is likely a promise (from dynamic import)
                            $panel.sliderInstance.then(slider => {
                                window.requestAnimationFrame(() => {
                                    if (slider && slider.slider) slider.slider.update();
                                });
                            });
                        }
                    }
                }
                if (setFocus) {
                    $tab.focus();
                }
            } else {
                $tab.classList.remove('image-content-switcher__tab-button--active');
                if ($panel) {
                    $panel.classList.remove('image-content-switcher__contents--active');
                    $panel.setAttribute('hidden', '');
                }
            }
        });

        if ($infoBar && infoBarRectBefore) {
            window.requestAnimationFrame(() => {
                const infoBarRectAfter = $infoBar.getBoundingClientRect();
                const diff = infoBarRectAfter.top - infoBarRectBefore.top;

                if (Math.abs(diff) > 1) {
                    window.scrollBy(0, diff);
                }
            });
        }
    }

    setSelectedToPreviousTab ($currentTab) {
        let index;

        if ($currentTab === this.$firstTab) {
            this.setSelectedTab(this.$lastTab);
        } else {
            index = this.$$tabs.indexOf($currentTab);
            this.setSelectedTab(this.$$tabs[index - 1]);
        }
    }

    setSelectedToNextTab ($currentTab) {
        let index;

        if ($currentTab === this.$lastTab) {
            this.setSelectedTab(this.$firstTab);
        } else {
            index = this.$$tabs.indexOf($currentTab);
            this.setSelectedTab(this.$$tabs[index + 1]);
        }
    }

    /* EVENT HANDLERS */
    onKeydown (event) {
        const $target = event.currentTarget;
        let flag = false;

        switch (event.key) {
        case 'ArrowLeft':
            this.setSelectedToPreviousTab($target);
            flag = true;
            break;

        case 'ArrowRight':
            this.setSelectedToNextTab($target);
            flag = true;
            break;

        case 'Home':
            this.setSelectedTab(this.$firstTab);
            flag = true;
            break;

        case 'End':
            this.setSelectedTab(this.$lastTab);
            flag = true;
            break;

        default:
            break;
        }

        if (flag) {
            event.stopPropagation();
            event.preventDefault();
        }
    }

    onClick (event) {
        this.setSelectedTab(event.currentTarget);
    }

    updateAllSliders () {
        this.$$tabPanels.forEach(($panel, index) => {
            const $tab = this.$$tabs[index];
            const isSelected = $tab.getAttribute('aria-selected') === 'true';

            if (isSelected) {
                if (!$panel.sliderInstance && !$panel.sliderInitializationStarted) {
                    this.initPanelSlider($panel);
                }
            }

            if ($panel.sliderInstance) {
                if ($panel.sliderInstance.slider) {
                    window.requestAnimationFrame(() => {
                        $panel.sliderInstance.slider.update();
                    });
                } else if (typeof $panel.sliderInstance.then === 'function') {
                    $panel.sliderInstance.then(slider => {
                        window.requestAnimationFrame(() => {
                            if (slider && slider.slider) slider.slider.update();
                        });
                    });
                }
            }
        });
    }
}

export { ImageContentSwitcher };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$imageContentSwitcher = $context.querySelectorAll('[data-imagecontentswitcher="root"]');

        if ($$imageContentSwitcher.length > 0) {
            for (let i = 0; i < $$imageContentSwitcher.length; i++) {
                const imageContentSwitcherAPI = new ImageContentSwitcher($$imageContentSwitcher[i]);
                $$imageContentSwitcher[i].imageContentSwitcherAPI = imageContentSwitcherAPI;
            }
        }
    }
});
